import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { AuthService } from '@et/auth';

@Component({
  selector: 'admin-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavbarComponent {
  private authService = inject(AuthService);

  showProfileMenu = false;

  /**
   * Log out the user.
   * @returns None
   * @memberof NavbarComponent
   */
  logout(): void {
    this.authService.logout();
  }
  /**
   * close profile menu when clicking out of element
   *
   * @param {MouseEvent} ev
   * @memberof NavbarComponent
   */
  closeProfileMenu(ev: MouseEvent) {
    ev.stopPropagation();
    if (this.showProfileMenu) {
      this.showProfileMenu = false;
    }
  }
}
